"use client";
import { useState } from "react";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

const QUESTIONS: ("q1" | "q2" | "q3" | "q4" | "q5" | "q6" | "q7" | "q8")[] = [
  "q1",
  "q2",
  "q3",
  "q4",
  "q5",
  "q6",
  "q7",
  "q8",
];

export const FaqSection = () => {
  const t = useTranslations("faq");
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="relative w-full py-20 md:py-28">
      <div className="mx-auto max-w-4xl px-4 md:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold leading-tight tracking-tight text-white">
            {t("heading")}
          </h2>
        </div>

        <div className="mt-14">
          {QUESTIONS.map((q, idx) => {
            const isOpen = open === idx;
            const aKey = `a${q.slice(1)}` as
              | "a1"
              | "a2"
              | "a3"
              | "a4"
              | "a5"
              | "a6"
              | "a7"
              | "a8";
            return (
              <div
                key={q}
                className={cn(
                  "border-b border-neutral-800",
                  idx === 0 && "border-t border-neutral-800"
                )}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : idx)}
                  className="group w-full flex items-start justify-between gap-6 py-5 md:py-6 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="text-base md:text-lg font-semibold text-neutral-100 group-hover:text-white">
                    {t(q)}
                  </span>
                  <span
                    className={cn(
                      "mt-1 shrink-0 flex h-6 w-6 items-center justify-center text-neutral-500 group-hover:text-white transition-transform",
                      isOpen && "rotate-45"
                    )}
                  >
                    <PlusIcon className="h-3 w-3" />
                  </span>
                </button>
                {isOpen && (
                  <div className="pb-6 md:pb-7 pr-12 text-sm md:text-base text-neutral-400 leading-relaxed max-w-prose">
                    {t(aKey)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

const PlusIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden
  >
    <path d="M12 5v14M5 12h14" />
  </svg>
);
